export enum ChipEnum {
  PRIMARY    = "chip-primary",
  SECONDARY  = "chip-secondary",
  TERTIARY   = "chip-tertiary",
  GRAY       = "chip-gray",
  AVISO      = "chip-aviso",
  APOIO_DARK = "chip-apoio-dark",
  APOIO_LIGHT= "chip-apoio-light"
}
